const base = new URL(`${window.location.protocol}//${window.location.host}`);
const downloadExtensions = ['.doc', '.docx', '.eps', '.xls', '.ppt', '.pptx', '.pdf', '.xlsx', '.tab', '.csv', '.zip', '.txt', '.vsd', '.vxd', '.xml', '.js', '.css', '.rar', '.exe', '.wma', '.mov', '.avi', '.wmv', '.mp3', '.wav', '.m4v', '.ics'];

window.digitalData = window.digitalData || [];

document.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', (event) => {
    const currentTarget = event.currentTarget;
    const eventAction = getEventAction(currentTarget);
    const dataLayerEvent = {
      event: {
        eventInfo: {
          action: eventAction,
          name: 'generic',
          type: eventAction === 'internal_link' ? 'storage' : 'trigger'
        },
        attributes: {
          componentPath: domComponentPath(currentTarget),
          label: getElementLabel(currentTarget),
          currentURL: window.location.href,
          targetURL: getTargetFullUrl(currentTarget),
          clickID: getAttributeTestId(currentTarget),
          elementName: getElementName(currentTarget),
          value: '',
          pos: ''
        }
      }
    };
    window.digitalData.push(dataLayerEvent);
  });
});

document.querySelectorAll('form').forEach((form) => {
  form.addEventListener('submit', (event) => {
    const currentTarget = event.currentTarget;
    const submitButton = currentTarget.querySelector('button[type="submit"]');

    const dataLayerEvent = {
      event: {
        eventInfo: {
          action: 'content',
          name: 'send form click - success',
          type: 'trigger'
        },
        attributes: {
          componentPath: domComponentPath(submitButton),
          label: getElementLabel(submitButton),
          currentURL: window.location.href,
          targetURL: '',
          clickID: getAttributeTestId(currentTarget),
          elementName: 'button',
          value: form.getAttribute('id') || '',
          pos: ''
        }
      }
    };

    window.digitalData.push(dataLayerEvent);
  });
});

function getEventAction(target) {
  const href = target.getAttribute('href');
  if (href.startsWith('mailto:')) {
    return 'mail'
  } else if (href.startsWith('tel:')) {
    return 'call'
  } else if (href.startsWith('#')) {
    return 'anchor'
  } else if (target.hasAttribute('download') || downloadExtensions.some(extension => href.endsWith(extension)) || target.classList.contains('download-item')) {
    return 'download'
  }
  if (isInternal(href)) {
    return 'internal_link'
  } else {
    return 'external_link'
  }
}

function getAttributeTestId(target) {
  return target.hasAttribute('data-testid') ? target.dataset.testid : '';
}

function getTargetFullUrl(target) {
  const href = target.getAttribute('href');
  return isInternal(href) && href.startsWith('/') ? new URL(href, base).href : href;
}

function getElementLabel(target) {
  let label = '';
  if (target.innerText) {
    label = target.innerText.trim();
  } else if (target.hasAttribute('title')) {
    label = target.getAttribute('title');
  } else if (target.hasAttribute('aria-label')) {
    label = target.getAttribute('aria-label');
  }

  return label.replace(/\s+/g, ' ').trim();
}

function getElementName(target) {
  const href = target.getAttribute('href');
  const classList = target.classList;
  const children = target.children;
  const role = target.getAttribute('role');

  if (classList.contains('btn') && href && !href.startsWith('#')) {
    return 'button';
  }
  if ((href && !target.childElementCount && target.innerText.trim() !== '') ||
    (classList.contains('text') || classList.contains('link'))) {
    return 'text-link';
  }
  if (href && target.childElementCount === 1 && target.firstElementChild.tagName.toLowerCase() === 'img') {
    return 'image';
  }
  if (href && (children.length === 1 && children[0].tagName.toLowerCase() === 'svg' || (children.length === 1 && children[0].tagName.toLowerCase() === 'div' && children[0].classList.contains('svg-icon')))) {
    return 'icon';
  }
  if (role === 'tab') {
    return 'tab';
  }
  if (classList.contains('accordion-button')) {
    return 'accordion';
  }

  return 'other';
}

function isInternal(url) {
  return new URL(url, base).hostname === base.hostname;
}

const domComponentPath = (function () {
  const proto = typeof Element !== 'undefined' ? Element.prototype : {};
  const vendor = proto.matches
    || proto.matchesSelector
    || proto.webkitMatchesSelector
    || proto.mozMatchesSelector
    || proto.msMatchesSelector
    || proto.oMatchesSelector;

  function match(el, selector) {
    if (!el || el.nodeType !== 1) return false;
    if (vendor) return vendor.call(el, selector);
    const nodes = el.parentNode.querySelectorAll(selector);
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i] == el) return true;
    }
    return false;
  }

  function getPosition(element, selector) {
    let matches = []
    const siblings = element.parentNode.children
    for (let i = 0; i < siblings.length; i++) {
      if (match(siblings[i], selector)) {
        matches.push(siblings[i])
      }
    }
    return matches.indexOf(element)
  }

  function getElementNameAndSelector(element) {
    const component = element.dataset.testid;
    if (component) {
      return {
        name: 'Component: ' + component,
        selector: '[data-testid="' + CSS.escape(component) + '"]'
      }
    }
    if (element.id) {
      return {
        name: 'ID: ' + element.id,
        selector: '#' + CSS.escape(element.id)
      }
    }
    let className = element.getAttribute('class')
    if (className) {
      className = className.replace(/(\s|\n)+/g, ' ').trim()
      const classSelector = '.' + className.split(' ').map(function (e) {
        return CSS.escape(e)
      }).join('.')
      return {
        name: 'Class: ' + className,
        selector: classSelector
      }
    }
    const tagName = element.tagName.toLowerCase()
    return {
      name: 'Tag: ' + tagName,
      selector: tagName
    }
  }

  return function domComponentPath(element) {
    let componentPath = []
    while (element && element !== document.body) {
      const eInfo = getElementNameAndSelector(element)
      const position = 1 + getPosition(element, eInfo.selector)
      componentPath.unshift({
        name: eInfo.name,
        position: position
      })
      element = element.parentElement
    }
    return componentPath
  }
})();
